import Vue from 'vue';
import MusicboxSetting from './setting';
import SysStatus from './sys-status';

/**
 * 返回组件生成的dom节点
 * @param {VueComponent} component
 * @param {any} data
 * @returns {Element}
 */
function genComponentEl(component, data) {
  const Component = Vue.extend(component);
  return new Component({ propsData: data || {} }).$mount().$el;
}

/**
 * 八音盒设置弹窗
 * @param {{ sn: string, deviceType: string }} data
 */
export function setting(data) {
  if (document.querySelector('.musicbox-setting-wrap')) return;
  const content = genComponentEl(MusicboxSetting, data);
  document.body.append(content);
}

/**
 * 八音盒系统状态弹窗
 * @param {{ sn: string, deviceType: string }} data
 */
export function sysStatus(data) {
  if (document.querySelector('.musicbox-status-wrap')) return;
  const content = genComponentEl(SysStatus, data);
  document.body.append(content);
}
